<template>
  <el-dialog
    :visible.sync="isShow"
    width="700px"
    title="编辑辅助配套设施信息"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="squadForm"
      :model="facilityInfo"
      style="height: 270px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        
        <el-row>
          <el-col :span="20">
            <el-form-item :label="facilityInfo.facilityName" :rules="{required: true}" label-width="280px">
              <el-radio-group v-model="facilityInfo.isCheck">
                <el-radio :label=true border>是</el-radio>
                <el-radio :label=false border>否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="facilityInfo.isCheck">
          <el-row>
            <el-col :span="20">
              <el-form-item label="上传证明材料" :error="uploadErroeMsg" :rules="{required: facilityInfo.isCheck}" label-width="150px">
                <el-upload
                  class="yioks-form-item"
                  :action="uploadPath"
                  :on-remove="handleRemoveFile"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccessFiler"
                  multiple
                  :limit="9"
                  :on-exceed="handleExceed"
                  :file-list="uploadFileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    <a style="color: #666;">单个上传文件大小不能超过50M,最多上传9个文件。</a>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </vue-scroll>
    </el-form>
    <div v-if="!loading" class="tip">带 * 号的为必填项</div>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addSquadCount"
      >确认</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 270px" />
  </el-dialog>
</template>

<script>
import formRules from '@/utils/formRules/siteFacilities'
import { squadPlayerSex } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import siteFacilities from '@/api/siteFacilities'
import coach from '@/api/coach'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },
  
  mixins: [formRules],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    addSquad: {
      type: Boolean,
      required: true
    },
    Info: {
      type: Object,
      required: true
    },
    squadUuid: {
      type: String,
      required: false
    },
  },
  data () {
    return {
      img: '',
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      facilityInfo: {
        facilityName: '',
        facilityType: '',
        isCheck: '',
      },
      loading: false,
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      fileListChangedFlag: false,
      ops,
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addSquad
      },
      set (val) {
        this.$emit('update:addSquad', val)
      }
    },
  },
  watch: {

  },
  created () {
    this.facilityInfo = this.Info;
    this.uploadFileList = this.Info.uploadFileList.map((item) => {
      const { fileName, fileUrl } = item;
      return {
        ...item,
        name: fileName,
        url: fileUrl
      };
    });
  },
  methods: {
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传9个文件，本次上传已经超过了限制。`);
    },
    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        targetSecondlyUuid: this.targetUuid,
        stageUuid: this.stageUuid,
        fileType: suffix
      };
      if (this.isEdit) {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
    },
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
      if(this.isEdit) {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    // 上传文件检测
    beforeUpload(file) {
       const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
       const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
        return false;
      }
       if (!fileType) {
         this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
         return false;
       }
      return fileLimit;
    },
    
    
    addSquadCount () {
      if(this.uploadFileList.length === 0 && this.facilityInfo.isCheck){
        this.$message.error("请上传文件")
        return
      }
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = siteFacilities.assistEdit
          let requestData = {
            click:this.facilityInfo.isCheck,
            facilityType:this.facilityInfo.facilityType,
            contractList:this.facilityInfo.isCheck ? this.uploadFileList : []
          }
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideAddsquadDialog', false)
              
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    
  }
}
</script>

<style scoped lang="stylus">
  .tip
    color red
    width 100%
    margin-left: 50px;
    word-break break-word
  .yioks-form-item
    width 340px
</style>
